<template>
    <div>
        <div>
            <div class="basicInfo">基本信息</div>
            <div class="flawBasic">
                <div>
                    <div><div class="flawBasicTitle">编号</div><div class="flawBasicVal">{{tieInDetail.code || '-'}}</div></div>
                    <div><div class="flawBasicTitle">材质</div><div class="flawBasicVal">{{tieInDetail.material || '-'}}</div></div>
                </div>
                <div>
                    <div><div class="flawBasicTitle">管长(m)</div><div class="flawBasicVal">{{tieInDetail.length || '-'}}</div></div>
                    <div><div class="flawBasicTitle">管径(mm)</div><div class="flawBasicVal">{{tieInDetail.diameter || '-'}}</div></div>
                </div>
                <div>
                    <div><div class="flawBasicTitle">埋深-起点(m)</div><div class="flawBasicVal">{{tieInDetail.buringDepthFrom || '-'}}</div></div>
                    <div><div class="flawBasicTitle">埋深-终点(m)</div><div class="flawBasicVal">{{tieInDetail.buringDepthTo || '-'}}</div></div>
                </div>
                <div>
                    <div><div class="flawBasicTitle">高程-起点(m)</div><div class="flawBasicVal">{{tieInDetail.elevationFrom || '-'}}</div></div>
                    <div><div class="flawBasicTitle">高程-终点(m)</div><div class="flawBasicVal">{{tieInDetail.elevationTo || '-'}}</div></div>
                </div>
            </div>
        </div>
        <div class="basicInfo1">
            <div class="tab-content" style="overflow: auto; max-height: 400px;">
                <div>
                    <div class="tieInWeldTitle">结构性缺陷</div>
                    <div style="margin: 0.2rem;">
                        <div style="margin: 0.3rem;">
                            <div style="color: #adadad;">结构性缺陷</div><div>{{ getPipeDefectName(defect.structGrade) }}</div>
                        </div>
                        <div style="margin: 0.3rem;">
                            <div style="color: #adadad;">管段修复</div><div>{{ getRepairIndexName(defect.structRepair) }}</div>
                        </div>
                    </div>
                    <div class="tieInWeldTitle">功能性缺陷</div>
                    <div style="margin: 0.2rem;">
                        <div style="margin: 0.3rem;">
                            <div style="color: #adadad;">功能性缺陷</div><div>{{ getFunctionDefectName(defect.alityGrade) }}</div>
                        </div>
                        <div style="margin: 0.3rem;">
                            <div style="color: #adadad;">管段修复</div><div>{{ getPipeSectionName(defect.alityRepair) }}</div>
                        </div>
                    </div>
                </div>
                <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div style="color:#00ffff;">◇ 缺陷管段</div>
                    <ButtonField text="+ 新增" @click="addPipe" v-if="Object.keys(defect).length > 0" secondary />
                </div>
            </div>
        </div>
        <areaTableList style="margin-top: 1rem" :showCheckbox="false" :list="tieInhList" :columns="tableColumns">
            <template #template-pictureUrl="{ item }">
                <div class="childImg">
                    <template v-if="item.pictureUrl && item.pictureUrl.trim()">
                        <div
                            v-for="(child, childIndex) in item.pictureUrl.split(';')"
                            :key="childIndex"
                            @click="showFullScreenImage(childIndex, item.pictureUrl.split(';'))"
                        >
                            <img :src="child.trim()" alt="" style="width: 20px; height: 20px;margin-right:0.1rem "/>
                        </div>
                    </template>
                    <template v-else>
                        <img src="/gis/noPng.png" alt="默认图片"
                             style="width: 20px; height: 20px;margin-right:0.1rem "/>
                    </template>
                </div>
            </template>
            <template #template-defectName="{ item }">
                <div>
                    {{ getDefectName(item) }}
                </div>
            </template>
            <template v-slot:actions="{ item }">
                <a-space>
                    <a href="#" @click.prevent="editText(item)">编辑</a>
                    <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </areaTableList>

        <div v-if="isFullScreen" class="full-screen-image" @click="closeFullScreenImage">
            <div class="image-container">
                <img :src="fullScreenImages[currentIndex]"  alt="Full Screen Image" />
                <div class="image-controls">
                    <button @click="prevImage">&lt;</button>
                    <button @click="nextImage">&gt;</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import areaTableList  from "@/views/topic/detection/area-table-list.vue";
export default {
    name: "flaw-detail",
    components:{
        areaTableList
    },
    props:{
        tieInhList:{
            type:Array,
            default:()=>[]
        },
        tieInDetail:{
            type:Object,
            default:()=>{}
        },
        defect:{
            type:Object,
            default:()=>{}
        },
    },
    data(){
        return{
            fullScreenImages:[],
            tableColumns:[
                {key: 'pictureUrl',title: '图片',field: 'img',infotype:'template',width: '100px'},
                {key: 'distance',title: '距离',field: 'distance',infotype:'text',width: '80px'},
                {key: 'defectName',title: '缺陷名称',field: 'defectName',infotype:'template',width: '100px'},
                {key: 'score',title: '分值',field: 'score',infotype:'text',width: '80px'},
                {key: 'grade',title: '等级',field: 'grade',infotype:'text',width: '80px'},
                {key: 'actions',title: '操作',field: 'actions', infotype: 'template',width: '100px'},
            ],
            list:[],
            form:{},
            isFullScreen: false,
            currentIndex: 0,
            pipeDefectList:[
                {name:'Ⅰ等级-无或有轻微缺陷，结构状况基本不受影响，但具有潜在变坏的可能',value:'Ⅰ'},{name:'Ⅱ等级-管段缺陷明显超过一级，具有变坏的趋势',value:'Ⅱ'},
                {name:'Ⅲ等级-管段缺陷严重，结构状况受到影响',value:'Ⅲ'},{name:'Ⅳ等级-管段存在重大缺陷，损坏严重或即将导致破坏',value:'Ⅳ'},
            ],
            repairIndexList:[
                {name:'Ⅰ等级-结构条件基本完好，不修复',value:'Ⅰ'},{name:'Ⅱ等级-结构在短期内不会发生破坏现象，但应做修复计划',value:'Ⅱ'},
                {name:'Ⅲ等级-结构在短期内可能会发生破坏，应尽快修复',value:'Ⅲ'},{name:'Ⅳ等级-结构已经发生或即将发生破坏，应立即修复',value:'Ⅳ'},
            ],
            functionDefectList:[
                {name:'Ⅰ等级-无或有轻微影响，管道运行基本不受影响',value:'Ⅰ'},{name:'Ⅱ等级-管道过流有一定的受阻，运行受影响不大',value:'Ⅱ'},
                {name:'Ⅲ等级-管道过流受阻比较严重，运行受到明显影响',value:'Ⅲ'}, {name:'Ⅳ等级-管道过流受阻很严重，即将或已经导致运行瘫痪',value:'Ⅳ'},
            ],
            pipeSectionList:[
                {name:'Ⅰ等级-没有明显需要处理的缺陷',value:'Ⅰ'},{name:'Ⅱ等级-没有立即进行处理的必要，但宜安排处理计划',value:'Ⅱ'},
                {name:'Ⅲ等级-根据基础数据进行全面的考虑，应尽快处理',value:'Ⅲ'},{name:'Ⅳ等级-输水功能受到严重影响，应立即进行处理',value:'Ⅳ'},
            ],
            structGrade: 'Ⅰ',
            structRepair: 'Ⅰ',
            alityGrade: 'Ⅰ',
            alityRepair: 'Ⅰ',
            defectRainStructureList:[
                { name: '(AJ)支管暗接', value: 'AJ' },{ name: '(BX)变形', value: 'BX' },{ name: '(CK)错口', value: 'CK' },{ name: '(CR)异物穿入', value: 'CR' },
                { name: '(FS)腐蚀', value: 'FS' },{ name: '(PL)破裂', value: 'PL' },{ name: '(QF)起伏', value: 'QF' },{ name: '(SL)渗漏', value: 'SL' },
                { name: '(TJ)脱节', value: 'TJ' },{ name: '(TL)接口材料脱落', value: 'TL' }
            ],
            defectRainFunctionList:[
                { name: '(CJ)沉积', value: 'CJ' },{ name: '(CQ)残墙、坝根', value: 'CQ' },{ name: '(FZ)浮渣', value: 'FZ' },{ name: '(JG)结垢', value: 'JG' },
                { name: '(SG)树根', value: 'SG' },{ name: '(ZW)障碍物', value: 'ZW' }
            ],
            defectSewageStructureList:[
                { name: '(AJ)支管暗接', value: 'AJ' },{ name: '(BX)变形', value: 'BX' },{ name: '(CK)错口', value: 'CK' },{ name: '(CR)异物穿入', value: 'CR' },
                { name: '(FS)腐蚀', value: 'FS' },{ name: '(PL)破裂', value: 'PL' },{ name: '(QF)起伏', value: 'QF' },{ name: '(SL)渗漏', value: 'SL' },
                { name: '(TJ)脱节', value: 'TJ' },{ name: '(TL)接口材料脱落', value: 'TL' }
            ],
            defectSewageFunctionList:[
                { name: '(CJ)沉积', value: 'CJ' },{ name: '(CQ)残墙、坝根', value: 'CQ' },{ name: '(FZ)浮渣', value: 'FZ' },{ name: '(JG)结垢', value: 'JG' },
                { name: '(SG)树根', value: 'SG' },{ name: '(ZW)障碍物', value: 'ZW' }
            ],
            defectTypeList:[
                {name:'结构性缺陷',value:'structure'},{name:'功能性缺陷',value:'function'},{name:'管段正常',value:'normal'}
            ],
            zcList:[{ name: '(ZC)正常', value: 'ZC' }],
        }
    },
    methods:{
        getDefectName(item) {
            const pipeType = this.tieInDetail.pipeType;
            const defectName = item.defectName;
            const serialNum = item.serialNum;

            if (serialNum === 'structure') {
                return pipeType === '污水'
                    ? this.defectSewageStructureList.find(d => d.value === defectName)?.name
                    : this.defectRainStructureList.find(d => d.value === defectName)?.name;
            } else if (serialNum === 'function') {
                return pipeType === '污水'
                    ? this.defectSewageFunctionList.find(d => d.value === defectName)?.name
                    : this.defectRainFunctionList.find(d => d.value === defectName)?.name;
            } else if (serialNum === 'normal') {
                return this.zcList.find(d => d.value === defectName)?.name;
            }
            return '';
        },
        getPipeDefectName(value) {
            const item = this.pipeDefectList.find(item => item.value === value);
            return item ? item.name : '';
        },
        getRepairIndexName(value) {
            const item = this.repairIndexList.find(item => item.value === value);
            return item ? item.name : '';
        },
        getFunctionDefectName(value) {
            const item = this.functionDefectList.find(item => item.value === value);
            return item ? item.name : '';
        },
        getPipeSectionName(value) {
            const item = this.pipeSectionList.find(item => item.value === value);
            return item ? item.name : '';
        },
        deleteText(item){
            this.$emit('delete',item);
            console.log("item:::",item)
        },
        editText(item){
            console.log("item:::",item)
            this.$emit('update',item);
        },
        showFullScreenImage(currentIndex, imageList) {
            this.currentIndex = currentIndex;
            this.fullScreenImages = imageList.map(img => img.trim());
            this.isFullScreen = true;
        },
        closeFullScreenImage() {
            this.isFullScreen = false;
        },
        addPipe(){
            this.$emit('save', this.form);
            this.$emit('pipeVisible',true)
        },
        prevImage(e) {
            e.stopPropagation();
            this.currentIndex = this.currentIndex === 0
                ? this.fullScreenImages.length - 1
                : this.currentIndex - 1;
        },
        nextImage(e) {
            e.stopPropagation();
            this.currentIndex = this.currentIndex === this.fullScreenImages.length - 1 ? 0 : this.currentIndex + 1;
        }
    }
}
</script>
<style scoped>
.info{
    display: flex;
    justify-content: center;
    color: #adadad;
}
.basicInfo{
    color: #00d4ff;
    border-left: 2px solid #00d4ff;
    padding-left: 0.5rem ;
    height: 15px;
    line-height: 15px;
    margin-bottom: 0.5rem;
}
.basicInfo1{
    margin: 0.5rem 0;
    color: #d5d5d5;
}
.tieInhInfo{
    display: flex;
    justify-content: start;
}
.flawBasic > div{
    display: flex;
    justify-content: start;
    font-size: 0.7rem;
}
.flawBasic > div > div{
    display: flex;
    justify-content: start;
    color: #adadad;
    width: 50%;
}
.flawBasicTitle{
    width: 50%;
}
.flawBasicVal{
    color: #67927F;
}

.tieInWeld{
    display: flex;
    justify-content: space-between;
}
.tieInWeld > div{
    width: 48%;
}
.tieInWeldTitle{
    color: #00ffff;
    font-size: 0.8rem;
    font-weight: bold;
}

.tieInInfo{
    display: flex;
    justify-content: start;
    color: #adadad;
    margin: 0.2rem 0;
    font-size: 0.7rem;
}
.tieInVal{
    color:var(--theme-color);
}

.tieInTitle{
    width: 50%;
}
.childImg{
    display: flex;
    justify-content: start;
}

.full-screen-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9000;
    overflow: auto;
}

.image-container {
    max-width: 90%;
    max-height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative; /* 关键：子元素（按钮）基于此定位 */
}

.image-container img {
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
}

.image-controls {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
}

.image-controls button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 0.3s;
}

.image-controls button:hover {
    background-color: rgba(0, 0, 0, 0.8);
}

.image-controls button:first-child {
    left: 10px;
    position: absolute;
}

.image-controls button:last-child {
    right: 10px;
    position: absolute;
}
</style>